module.exports = __webpack_public_path__ + "img/c1.8dc46d5f.png";